import { useMutation, useQueryClient } from "@tanstack/react-query";
import { extendBundleValidity } from "../services/extend-bundle-validity";
import { useToast } from "@/hooks/use-toast";

interface ExtendBundleParams {
  usage_id: string;
  end_date: string;
  userId: string;
}

export const useExtendBundle = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ usage_id, end_date }: ExtendBundleParams) =>
      extendBundleValidity({ usage_id, end_date }),

    onSuccess: (_, { userId }) => {
      queryClient.invalidateQueries({ queryKey: ["user", userId] });
      toast({
        title: "Success",
        description: "Bundle validity extended successfully",
      });
    },

    onError: (error) => {
      toast({
        title: "Error",
        description: error.message ?? "Failed to extend bundle validity",
        variant: "destructive",
      });
    },
  });
};
